module.exports = __webpack_public_path__ + "img/Roberto-Hernandez.775432ad.png";